import {
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  cancel,
  clientSearchByName,
  clientGetPage,
  processRemind,
} from '@/api/remindserv'

export default {
  state: {
    state_Remind_SearchByNameResult: null,
    state_Remind_GetPageResult: null,
    state_Remind_GetDetailResult: null,
    state_Remind_DeleteObjResult: null,
    state_Remind_CancelResult: null,
    state_Remind_ClientSearchByNameResult: null,
    state_Remind_ClientGetPageResult: null,
    state_Remind_ProcessRemindResult: null,
  },
  mutations: {
    SET_REMIND_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_Remind_SearchByNameResult = rst;
    },
    SET_REMIND_GETPAGE_RESULT: (state, rst) => {
      state.state_Remind_GetPageResult = rst;
    },
    SET_REMIND_GETDETAIL_RESULT: (state, rst) => {
      state.state_Remind_GetDetailResult = rst;
    },
    SET_REMIND_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Remind_DeleteObjResult = rst;
    },
    SET_REMIND_CANCEL_RESULT: (state, rst) => {
      state.state_Remind_CancelResult = rst;
    },
    SET_REMIND_CLIENTSEARCHBYNAME_RESULT: (state, rst) => {
      state.state_Remind_ClientSearchByNameResult = rst;
    },
    SET_REMIND_CLIENTGETPAGE_RESULT: (state, rst) => {
      state.state_Remind_ClientGetPageResult = rst;
    },
    SET_REMIND_PROCESSREMIND_RESULT: (state, rst) => {
      state.state_Remind_ProcessRemindResult = rst;
    },
  },
  actions: {
    RemindServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REMIND_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REMIND_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RemindServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REMIND_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REMIND_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RemindServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REMIND_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REMIND_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RemindServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REMIND_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REMIND_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RemindServ_Cancel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REMIND_CANCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REMIND_CANCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RemindServ_ClientSearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientSearchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REMIND_CLIENTSEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REMIND_CLIENTSEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RemindServ_ClientGetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientGetPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REMIND_CLIENTGETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REMIND_CLIENTGETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RemindServ_ProcessRemind({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        processRemind(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_REMIND_PROCESSREMIND_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_REMIND_PROCESSREMIND_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Remind_SearchByNameResult: state => {
      return state.state_Remind_SearchByNameResult;
    },
    get_Remind_GetPageResult: state => {
      return state.state_Remind_GetPageResult;
    },
    get_Remind_GetDetailResult: state => {
      return state.state_Remind_GetDetailResult;
    },
    get_Remind_DeleteObjResult: state => {
      return state.state_Remind_DeleteObjResult;
    },
    get_Remind_CancelResult: state => {
      return state.state_Remind_CancelResult;
    },
    get_Remind_ClientSearchByNameResult: state => {
      return state.state_Remind_ClientSearchByNameResult;
    },
    get_Remind_ClientGetPageResult: state => {
      return state.state_Remind_ClientGetPageResult;
    },
    get_Remind_ProcessRemindResult: state => {
      return state.state_Remind_ProcessRemindResult;
    },
  }
}